var $ab711d2ffb4cdf3d$exports = {};
$ab711d2ffb4cdf3d$exports = {
  "breadcrumbs": "Lingiread"
};
export { $ab711d2ffb4cdf3d$exports as default };